module.exports = __webpack_public_path__ + "fonts/NespressoLucas-LightItalic.woff2?v=ed836083474a29bdf468594fc2df9dc7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-LightItalic.woff2
// module id = 660
// module chunks = 0